/*
==========================================================
Ankur Collection Gallery v2.1
Author: Ankur
==========================================================
*/

(function () {
    'use strict';

    const ROTATE_INTERVAL = 700;
    const MOBILE_INTERVAL = 1500;

    document.addEventListener('DOMContentLoaded', () => {
        document
            .querySelectorAll('.ankur-collection-gallery')
            .forEach(initGallery);
    });

    function initGallery(gallery) {

        const firstImage = gallery.querySelector('.ankur-gallery-image');
        if (!firstImage) return;

        const json = gallery.querySelector('.ankur-gallery-data');
        if (!json) return;

        let urls = [];

        try {
            urls = JSON.parse(json.textContent.trim());
        } catch (e) {
            console.error('Ankur Gallery JSON Error', e);
            return;
        }

        if (!urls.length) return;

        let images = [firstImage];
        let loaded = false;
        let timer = null;
        let current = 0;

        function loadGallery() {

            if (loaded) return;

            loaded = true;

            gallery.classList.add('loading');

            urls.forEach((url, index) => {

                const img = document.createElement('img');

                img.src = url;
                img.alt = firstImage.alt + ' ' + (index + 2);
                img.loading = 'lazy';
                img.decoding = 'async';
                img.width = firstImage.width || 600;
                img.height = firstImage.height || 600;
                img.className = 'ankur-gallery-image';

                gallery.appendChild(img);

                images.push(img);

            });

            gallery.classList.remove('loading');

        }

        function show(index) {

            images.forEach(img => img.classList.remove('active'));

            images[index].classList.add('active');

            const dots = gallery.querySelectorAll('.ankur-gallery-dot');

            dots.forEach((dot, i) => {
                dot.classList.toggle('active', i === index);
            });

            current = index;

        }

        function next() {

            current++;

            if (current >= images.length) {
                current = 0;
            }

            show(current);

        }

        function stopRotation() {

            if (timer) {
                clearInterval(timer);
                timer = null;
            }

        }

        function startRotation() {

            loadGallery();

            stopRotation();

            timer = setInterval(next, ROTATE_INTERVAL);

        }

        /* ==========================================
           Desktop Hover
        ========================================== */

        if (window.matchMedia('(hover: hover)').matches) {

            gallery.addEventListener('mouseenter', startRotation);

            gallery.addEventListener('mouseleave', function () {

                stopRotation();

                show(0);

            });

        }

        /* ==========================================
           Mobile Auto Slider
        ========================================== */

        if (window.matchMedia('(hover: none)').matches) {

            loadGallery();

            clearInterval(timer);

            timer = setInterval(next, MOBILE_INTERVAL);

        }

        /* ==========================================
           Touch Support
        ========================================== */

        let touchStartX = 0;

        gallery.addEventListener('touchstart', function (e) {

            loadGallery();

            touchStartX = e.touches[0].clientX;

            stopRotation();

        }, { passive: true });

        gallery.addEventListener('touchend', function (e) {

            const diff = touchStartX - e.changedTouches[0].clientX;

            if (Math.abs(diff) > 40) {

                if (diff > 0) {

                    current++;

                    if (current >= images.length) {
                        current = 0;
                    }

                } else {

                    current--;

                    if (current < 0) {
                        current = images.length - 1;
                    }

                }

                show(current);

            }

            if (window.matchMedia('(hover: none)').matches) {

                clearInterval(timer);

                timer = setInterval(next, MOBILE_INTERVAL);

            }

        }, { passive: true });

        /* ==========================================
           Page Visibility
        ========================================== */

        document.addEventListener('visibilitychange', function () {

            if (document.hidden) {

                stopRotation();

            } else {

                if (window.matchMedia('(hover: none)').matches) {

                    clearInterval(timer);

                    timer = setInterval(next, MOBILE_INTERVAL);

                }

            }

        });

    }

})();